import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CommonService } from '../../Common/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SelectClientService } from '../select-client/select-client.service';
import { AuthTokenService } from '../../core/auth/auth-token.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService implements CanActivate {
  registeredUserEmail: string = '';
  client_list: any;
  constructor(
    private jwtHelper: JwtHelperService,
    private _commonService: CommonService,
    private _selectClientService: SelectClientService,
    private router: Router,
    private _matSnackBar: MatSnackBar,
    private _httpClient: HttpClient,
    private authTokenService: AuthTokenService) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.authTokenService.ensureValidAccessToken().pipe(
      switchMap((authenticated) => {
        // Transient refresh failure must not log out if 30-day refresh token is still valid
        if (!authenticated && !this.authTokenService.hasValidRefreshToken()) {
          this.router.navigate(["login"]);
          return of(false);
        }
        if (!authenticated && this.authTokenService.hasValidRefreshToken()) {
          // Retry once: overnight first call can fail due to network blip
          return this.authTokenService.refreshAccessToken(true).pipe(
            switchMap((retried) => {
              if (!retried && !this.authTokenService.hasValidRefreshToken()) {
                this.router.navigate(["login"]);
                return of(false);
              }
              if (!retried) {
                // Keep session; subsequent API 401 handler will refresh/retry
                return of(true);
              }
              return this.ensureUserLoaded().pipe(
                switchMap(() => this.continueCanActivate(state))
              );
            })
          );
        }

        return this.ensureUserLoaded().pipe(
          switchMap(() => this.continueCanActivate(state))
        );
      })
    );
  }

  /** Load profile/menu permissions when APP_INITIALIZER missed getUserByToken (e.g. expired access). */
  private ensureUserLoaded(): Observable<boolean> {
    const userLoaded =
      this._commonService.client_access_id > 0 ||
      this._commonService.admin_id > 0 ||
      !!this._commonService.email_id;

    if (userLoaded || !this.authTokenService.accessToken) {
      return of(true);
    }

    return this._commonService.getUserByToken().pipe(
      map(() => true),
      catchError(() => of(true))
    );
  }

  private continueCanActivate(state: RouterStateSnapshot): Observable<boolean> {
    if (state.url != "/select-client" && this._commonService.client_id == 0 && this._commonService.client_access_id > 0) {
      this._selectClientService.getClientsList("").then((response: any) => {
        this.client_list = response;
        if (this.client_list != null && this.client_list != undefined && this.client_list.length > 0) {
          var select_client_req_data = {
            client_access_id: this._commonService.client_access_id,
            client_id: this._selectClientService.clients_list[0].client_id
          };
          this._commonService.selectClient(select_client_req_data).subscribe((response: any) => {
            if (response != null && response.status == true) {
              this._commonService.getUserByToken().subscribe();
              window.location.href = "/dashboard";
            }
            else {
              this._matSnackBar.open(this._commonService.getTranslatedText("SelectACompany"), 'OK', {
                verticalPosition: "top",
                duration: 5 * 1000
              });
              this.router.navigate(["select-client"]);
            }
          });
        }
        else {
          this._matSnackBar.open(this._commonService.getTranslatedText("SelectACompany"), 'OK', {
            verticalPosition: "top",
            duration: 5 * 1000
          });
          this.router.navigate(["select-client"]);
        }
      });
    }
    else if (this._commonService.account_status == 1) {
      alert(this._commonService.getTranslatedText("AccountIsInactive"));
      this.router.navigate(["login"]);
    }
    return of(true);
  }

  loginUser<T>(credentials): Observable<any> {
    return this._httpClient.post<number>("api/auth/login", JSON.stringify(credentials), {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    });
  }

  sendOTP<T>(sendOTP: any): Observable<T> {
    return this._httpClient.post<any>('/api/auth/sendotp', sendOTP, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }

  verifyOTP<T>(verifyOTP): Observable<any> {
    return this._httpClient.post<number>("api/auth/verifyotp", verifyOTP, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    });
  }

  SaveToken<T>(customerCardToken): Observable<any> {
    return this._httpClient.post<number>("api/auth/SaveToken", JSON.stringify(customerCardToken), {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    });
  }
}
